import styled from 'styled-components';

export const TabRegulationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 0;
`;

export const SectionTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
`;

export const FilesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 16px;
`;

export const FileItem = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
`;

export const PhotoItem = styled(FileItem)`
  > div {
    cursor: pointer;
    width: 100%;
  }

  img {
    width: 100%;
    height: 120px;
    object-fit: cover;
    border-radius: 8px;
  }
`;

export const DocumentItem = styled(FileItem)`
  > div {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  img {
    width: 60px;
    height: 60px;
  }
`;

export const DeleteButton = styled.button`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.9);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(255, 255, 255, 1);
  }

  img {
    width: 16px;
    height: 16px;
  }
`;

export const EmptySection = styled.div`
  text-align: center;
  color: #666;
  font-size: 14px;
  padding: 24px;
`;

export const FileTitle = styled.p`
  font-size: 12px;
  color: #333;
  text-align: center;
  margin: 8px 0 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 120px;
  cursor: pointer;
`;
